module.exports = __webpack_public_path__ + "static/media/p6.710b80cb.png";